import axios from 'axios';
import { Capacitor } from '@capacitor/core';

export const API_BASE_URL = process.env.REACT_APP_API_URL
  || (Capacitor.isNativePlatform() ? 'https://api.demarcheur.org/api' : '/api');

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/connexion';
    }
    return Promise.reject(err);
  }
);

export default api;
